import mq from 'js-mq';
import attrs from 'js-mq-attrs'; // importing for side effects

mq.register([
    {name: 'xs', query: '(max-width: 767px)'},
    {name: 'nav-main-mobile', query: '(max-width: 1020px)'},

    {name: 'sm', query: '(max-width: 991px)'},
    {name: 'md', query: '(max-width: 1199px)'},
    {name: 'lg', query: '(min-width: 1200px)'},
    {name: 'sm-only', query: '(min-width: 768px) and (max-width: 991px)'},
    {name: 'lt-md', query: '(max-width: 991px)'},
    {name: 'gt-sm', query: '(min-width: 992px)'},
    {name: 'gt-xs', query: '(min-width: 768px)'}
]);
